// extracted by css-extract-rspack-plugin
export default {"root":"DottedBackground-module__root___Qlly_"};